module.exports = __webpack_public_path__ + "static/media/image.5722bd38.jpg";